import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { PrismService } from "../../prism.service";
import { UserSignature, UserSignatureDTO } from "@features/bb-formio/dto/user-signature";
import { UserSignatureService } from "@features/bb-formio/services/user-signature.service";
import { ExtendedComponentSchema, FormioComponent, FormioForm } from "@formio/angular";
import { UserService } from "@main/users";
import { ConfirmationService } from "primeng/api";
import * as moment from "moment";

@Component({
    selector: "bb-user-signature",
    templateUrl: "./user-signature.component.html",
    styleUrls: ["../../formio.styles.scss", "./user-signature.component.scss"]
})
export class BbUserSignatureComponent implements AfterViewInit, OnInit {
    public formJson: any = {};
    public formOptions: any = {};

    refreshForm = new EventEmitter();
    dataSubmitted = false;

    @Output() readonly onSignatureSubmitted = new EventEmitter<any>();

    @ViewChild("formioForm") formioForm: FormioComponent;

    constructor(public prism: PrismService,
        private userService: UserService,
        public userSignatureService: UserSignatureService,
        public http: HttpClient,
        private confirmationService: ConfirmationService
    ) {
        // Function to handle submission with custom error handling
        const beforeSubmit = async (submission, callback) => {
            try {

                const formData = <UserSignatureDTO>{
                    signature: JSON.stringify(submission.data.signature),
                    userId: this.userService.currentUser.id ?? "",
                }
                // // this.dataSubmitted = await this.userSignatureService.setSignature(formData);
                // // if (!this.dataSubmitted) {
                // //     throw new Error("Data submission failed.");
                // // }

                var contentType = "image/png";
                var base64Data = (submission.data.signature).split(",")[1] ?? "";

                var blob = this.b64toBlob(base64Data, contentType, null);
                var file = new File([blob], "signature.png", { type: contentType });

                this.onSignatureSubmitted.emit(file)

                callback(null, submission);

                // // const formData1 = new FormData();
                // // formData1.append(file.name, file);
                // // formData1.append("last_modified", moment(file.lastModified).toDate().toUTCString());

                // // await this.userService.uploadSignatureImage(formData1)
            } catch (error) {
                setTimeout(function () {
                    callback({
                        message: error,
                        component: null
                    }, null);
                }, 200);
            } finally {
                // To remove animation from the Buttons
                this.refreshForm.emit({
                    form: this.formJson
                });
            }
        }
        // Add the beforeSubmit function as a hook
        this.formOptions = {
            "hooks": {
                "beforeSubmit": beforeSubmit
            }
        }
    }

    ngAfterViewInit() {
        this.prism.init();
    }

    // Recursive method to explore and expand each component and its inner components to inject values on its data field accordingly
    getInnerComponents(component: ExtendedComponentSchema, userSignature: UserSignature) {
        const children = component["components"];
        if (children && userSignature) {
            children.forEach(element => {
                // Call recursively to process inner components
                switch (element.key) {
                    case "name":
                        element.defaultValue = userSignature.name;
                        break;
                    case "username":
                        element.defaultValue = userSignature.username;
                        break;
                    case "signature":
                        element.defaultValue = JSON.parse(userSignature.signature) ?? ""
                        break;
                }
            });

        }
    }

    getInnerComponentSignature(component: ExtendedComponentSchema) {
        const children = component["components"];
        if (children) {
            children.forEach(element => {
                if (element.key == "signature") {
                    element.defaultValue = "";
                    this.formioForm.initialize();
                }
            });
        }
    }

    async ngOnInit() {
        // // const result = await this.userSignatureService.getSignature(this.userService.currentUser.id);

        window.addEventListener("clearSignatureEvent", (event) => {

            this.getInnerComponentSignature(this.formJson);
            this.refreshForm.emit({
                form: this.formJson,
                submission: {
                    "signature": ""
                }
            });
        });

        const json = {
            "components": [

                {
                    "label": "",
                    "backgroundColor": "rgb(255,255,255)",
                    "tableView": false,
                    "key": "signature",
                    "type": "signature",
                    "input": false,
                    "modalEdit": true,
                    "minWidth": 0.5,
                    "maxWidth": 0.5,

                },
                {
                    "label": "",
                    "key": "table",
                    "type": "table",
                    "customClass": "signature-buttons",
                    "numRows": 1,
                    "numCols": 2,
                    "input": false,
                    "tableView": false,
                    "rows": [
                        [
                            {
                                "components": [
                                    {
                                        "label": "Submit",
                                        "showValidations": false,
                                        "leftIcon": "pi pi-check-circle",
                                        "disableOnInvalid": true,
                                        "tableView": false,
                                        "key": "submit",
                                        "type": "button",
                                        "customClass": "p-element m-button-primary mb-1 p-component ng-star-inserted",
                                        "saveOnEnter": false,
                                        "input": true
                                    }
                                ]
                            }
                        ]
                    ]
                }
            ]
        }



        this.formJson = json;
        this.getInnerComponents(this.formJson, null);
        this.refreshForm.emit({
            form: this.formJson
        });
    }

    // Send the signature for saving into DB
    async submitData($event) {
        const formData = <UserSignatureDTO>{
            signature: JSON.stringify({ data: $event.data.signature }),
            userId: this.userService.currentUser.id ?? "",
        }
        this.dataSubmitted = await this.userSignatureService.setSignature(formData);

        var contentType = "image/png";
        var base64Data = ($event.data.signature).split(",")[1];
        var blob = this.b64toBlob(base64Data, contentType, null);
        var file = new File([blob], "signature.png", { type: contentType });

        const formData1 = new FormData();
        formData1.append(file.name, file);
        formData1.append("last_modified", moment(file.lastModified).toDate().toUTCString());

        this.userService.uploadSignatureImage(formData1)
    }

    confirm() {
        this.confirmationService.confirm({
            message: "Are you sure that you want to close this tab?",
            accept: () => {
                window.close();
            }
        });
    }

    base64ToFile(base64String, filename) {
        var mimeType = "";
        var sliceSize = 1024;
        var byteCharacters = atob(base64String);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: mimeType });
        return new File([blob], filename, { type: mimeType });
    }

    // Function to convert base64 to blob
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
        }

}
